import { useEffect } from 'react'
import { setupAxiosInterceptors } from '../services/axiosConfig.js'
import useAuthStore from '../store/useAuthStore.js'

export default function useAuthRuntime() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const getAccessToken = useAuthStore((state) => state.getAccessToken)
  const refreshToken = useAuthStore((state) => state.refreshToken)
  const logout = useAuthStore((state) => state.logout)
  const tokenTimestamp = useAuthStore((state) => state.tokenTimestamp)
  const isTokenExpiringSoon = useAuthStore((state) => state.isTokenExpiringSoon)

  useEffect(() => {
    if (!isAuthenticated) return undefined
    return setupAxiosInterceptors(getAccessToken, refreshToken, logout)
  }, [isAuthenticated, getAccessToken, refreshToken, logout])

  useEffect(() => {
    if (!isAuthenticated) return undefined
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && isTokenExpiringSoon()) refreshToken().catch(() => {})
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [isAuthenticated, refreshToken, tokenTimestamp, isTokenExpiringSoon])

  useEffect(() => {
    if (!isAuthenticated) return undefined
    const timer = globalThis.setInterval(() => {
      if (isTokenExpiringSoon()) refreshToken().catch(() => {})
    }, 30000)
    return () => globalThis.clearInterval(timer)
  }, [isAuthenticated, refreshToken, isTokenExpiringSoon])
}
